import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";

import { Dialog } from "primereact/dialog";
import { format } from "date-fns";

import { Button } from "primereact/button";
import { Interview_Process, IRequirementMast } from "../../../models/RequirementMast";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { Publish } from "../../requirement/Publish";

interface Iprops {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    salEffFilter: any,
    salesID?: number,
    resType: number,
    catID?: number,
    branchID?: number,
    recType?: string,
    totalRec?: boolean | null,
}

const popupHeader = (resType: number): string => {
    if (resType === 1) return "Recruiter Wise Requirement Report";
    else if (resType === 2) return "Recruiter Onsite Requirement Report";
    else if (resType === 3) return "Recruiter Hybrid Requirement Report";
    else if (resType === 4) return "Recruiter Remote Requirement Report";
    else if (resType === 5) return "Recruiter Served Requirement Report";
    else if (resType === 6) return "Recruiter UnServed Requirement Report";
    else if (resType === 7) return "Requirement Wise Recruiter Submission Report";
    else return "Report";
}

export const SkillSubTableReport = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<{ sn: number }>, loading: boolean });
    const [publish, setPublish] = useState({ singleData: {}, open: false } as { singleData: { req_ID?: number }, open: boolean });
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };

    const dt = useRef<any>(null);
    const dt2 = useRef<any>(null);

    const exportCSV = () => {
        dt.current.exportCSV();
    };
    const exportCSV2 = () => {
        dt2.current.exportCSV();
    };

    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);


    const loadTableData = async () => {
        console.log("props", props);
        setTableData({ tableData: [], loading: true });
        let filterQuery = "";
        if (props.catID)
            filterQuery += `&catID=${props?.catID}`;
        if (props.salesID)
            filterQuery += `&salesID=${props.salesID}`;
        if (props.branchID)
            filterQuery += `&branchID=${props.branchID}`;

        if (props.recType) {
            filterQuery += `&recType=${props?.recType}`;
        }
        if (props.totalRec === true) {
            filterQuery += `&totalRec=${props?.totalRec}`;
        }
        const response = await Fetch("Report_Skill_Recruiter/report", "GET", null, `filter=${JSON.stringify(props.salEffFilter)}&resType=${props.resType}` + filterQuery, props.toast);
        if (response) {
            const data: Array<{ sn: number }> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const onHide = () => {
        props.hideDialog();
    }




    const downloadResume = async (path: string) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/msword',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Resume_Mast/download"}?path=${path}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${path}`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">{popupHeader(props.resType)}</h5>
            <Button label="Export" icon="pi pi-upload" className="p-button-help w-8rem mr-3" onClick={exportCSV} />
        </div>
    );
    const header2 = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Report</h5>
            <Button label="Export" icon="pi pi-upload" className="p-button-help w-8rem mr-3" onClick={exportCSV2} />
        </div>
    );

    const req_Job_Title = (rowData: { req_ID: number, req_Job_Title: string }) => {
        return (<span onClick={() => setPublish({ singleData: { req_ID: rowData.req_ID }, open: true })}
            className="cursor-pointer text-cyan-700 underline">
            {rowData.req_Job_Title}
        </span>);
    };

    return (<>
        <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req ID" sortable />
                <Column field="user_Name" header="Sales Manager" sortable />
                <Column field="branch_Name" header="Branch" sortable />
                <Column field="req_Job_Title" header="Job Title" sortable body={req_Job_Title} />
                <Column field="req_Duration" header="Req Duration" sortable />
                <Column field="location" header="Location" />
                <Column field="req_Rate" header="Req Rate" sortable />
                <Column field="req_InterviewProcess" header="InterviewProcess" body={(rowData: any) => rowData.req_InterviewProcess ? Interview_Process[rowData.req_InterviewProcess] : ""} />
                {props.resType === 7 ? <Column field="resume" header="#Resume" sortable /> :
                    <Column field="resume" header="#Resume" sortable />}
                <Column field="eci" header="#ECI" sortable />
                <Column field="po" header="#PO" sortable />
                <Column field="status" header="Status" />
                <Column field="allocationTime" header="Allocation Time" body={(rowData) => <p>{new Date(rowData.allocationTime).getHours() <= 12 ? new Date(rowData.allocationTime).getHours() : (new Date(rowData.allocationTime).getHours() - 12)}:{new Date(rowData.allocationTime).getMinutes()} {new Date(rowData.allocationTime).getHours() <= 12 ? "A.M." : "P.M."}</p>} />
            </DataTable>
        </Dialog>

        <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />

    </>
    );
}